// Quick add to cart from product cards (collection / catalog grid).
// Adds the main (first available) variant via AJAX and refreshes the mini-cart,
// reusing the theme's own "mini-ajax" cart view.
(function () {
  const ADD_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url
    ? window.Theme.routes.cart_add_url
    : '/cart/add') + '.js';
  const CART_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';

  // Pull fresh cart count + mini-cart markup from the theme's mini-ajax view and
  // patch them into the page (mirrors grid.js updateCart, without the bundled deps).
  async function refreshMiniCart() {
    const res = await fetch(CART_URL + '?view=mini-ajax', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) return;

    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

    const dataTpl = doc.querySelector('template[data-data]');
    if (dataTpl) {
      try {
        const data = JSON.parse(dataTpl.content.textContent.trim());
        document.querySelectorAll('.cart-count-number').forEach(el => {
          el.innerText = data.itemCount;
        });
      } catch (e) { /* ignore malformed data */ }
    }

    const miniTpl = doc.querySelector('template[data-html="miniCart"]');
    const currentWrapper = document.querySelector('.mini-cart-item-wrapper');
    if (miniTpl && currentWrapper) {
      const newWrapper = miniTpl.content.querySelector('.mini-cart-item-wrapper');
      if (newWrapper) currentWrapper.replaceWith(newWrapper.cloneNode(true));
    }

    const miniCart = document.querySelector('.mini-cart');
    if (miniCart) miniCart.classList.remove('empty');
  }

  async function quickAdd(trigger) {
    const variantId = trigger.dataset.variantId;
    if (!variantId || trigger.classList.contains('is-loading')) return;

    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(ADD_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Add to cart failed: ' + res.status);

      await refreshMiniCart();
    } catch (err) {
      console.error('[quick-add]', err);
      // Let the shopper resolve it on the product page.
      if (trigger.href) window.location.href = trigger.href;
    } finally {
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a[data-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    quickAdd(trigger);
  });
})();
